"use client";
import { useEffect, useState, useRef } from "react";
import Image from "next/image";
import { useDarkMode } from "../darkModeContext";
import { useTranslation } from "react-i18next";
import dataConstruction from "../construction/constructionSteps.json";
import dataMeca from "../mecanicals/mecanicals.json";

export default function Carousel({ type, stepID }) {

    let data;

    if (type === "constructionSteps") {
        data = dataConstruction;
    } else {
        data = dataMeca;
    }

    const { t } = useTranslation('constructionSteps');
    const isDarkMode = useDarkMode();
    const sortedData = data.find((item) => item.stepID === stepID);
    console.log(sortedData)
    const totalSlides = sortedData.imagePath.length;
    const [currentSlide, setCurrentSlide] = useState(0);
    const touchStartX = useRef(0);
    const touchEndX = useRef(0);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            import('bootstrap/dist/js/bootstrap.bundle.min.js');
            setCurrentSlide(0);
        }
    }, [stepID]);

    const handleTouchStart = (e) => {
        touchStartX.current = e.touches[0].clientX;
    };

    const handleTouchMove = (e) => {
        touchEndX.current = e.touches[0].clientX;
    };

    const handleTouchEnd = () => {
        const diff = touchStartX.current - touchEndX.current;

        // Minimum swipe distance to trigger the action
        const minSwipeDistance = 50;

        if (diff > minSwipeDistance) {
            // Swiped left
            goToNextSlide();
        } else if (diff < -minSwipeDistance) {
            // Swiped right
            goToPrevSlide();
        }
    };

    const goToNextSlide = () => {
        setCurrentSlide((prevIndex) => (prevIndex + 1) % totalSlides);
    };

    const goToPrevSlide = () => {
        setCurrentSlide((prevIndex) =>
            prevIndex === 0 ? totalSlides - 1 : prevIndex - 1
        );
    };

    return (
        <div
            id={`carouselControls-${stepID}`}
            className={`carousel slide mb-0 w-full ${(type === "constructionSteps") ? 'md:aspect-[4/3]' : 'md:aspect-[5/6]'} shadow-sm rounded-sm ${isDarkMode ? 'bg-carousel-dark' : 'bg-carousel-light'}` }
            data-bs-ride="false"
            data-bs-interval="false"
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
        >

        <div className={`carousel-inner ${(type === "constructionSteps") ? 'aspect-[4/3]' : 'aspect-[5/6]'} w-full md:h-full rounded-sm flex items-center`}>
                {sortedData.imagePath.map((path, index) => (
                    <div
                        key={index}
                        className={`carousel-item relative aspect-square md:aspect-auto w-full h-full m-auto ${index === 0 ? "active" : ""}`}
                        style={{ display: index === currentSlide ? "block" : "none" }}
                    >
                        {/* Show loader under image */}
                        <div className="absolute inset-0 flex justify-center items-center">
                            <div className="loader"></div> 
                        </div>

                        <Image
                            src={path}
                            alt={t(`${stepID}.alt`)}
                            layout="fill"
                            className="d-block object-cover md:object-contain"
                        />
                    </div>
                ))}
            </div>
        {/* Hide buttons if there's only one image */}
        {totalSlides > 1 && (
            <>
                <button
                    className="carousel-control-prev hidden md:block"
                    type="button"
                    onClick={goToPrevSlide}
                >
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button
                    className="carousel-control-next hidden md:block"
                    type="button"
                    onClick={goToNextSlide}
                >
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                </button>

                <ul className="carousel-indicators">
                    {sortedData.imagePath.map((_, index) => (
                        <li
                            key={index}
                            className={`cursor-pointer ${index === currentSlide ? "active" : ""}`}
                            onClick={() => setCurrentSlide(index)}
                            data-bs-target={`#carouselControls-${stepID}`}
                            data-bs-slide-to={index}
                            aria-label={`Slide ${index + 1}`}
                        ></li>
                    ))}
                </ul>
            </>
        )}
        </div>
    );
}
